<div class="match-tune-card">
  <header class="card-head">
    <div class="text">
      <h2>Match and Tune Files</h2>
      <p>Upload a stock file — automatic ECU detection.</p>
    </div>
    <span class="ready-pill"><span class="dot"></span> READY</span>
  </header>

  <label class="dropzone" appDragAndDrop (fileDropped)="onFileDropped($event)">
    <input type="file" class="dropzone-file-input" (change)="onBrowseChange($event)" />
    <div class="dropzone-icon-wrap" aria-hidden="true">
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 16V4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5 11l7-7 7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5 20h14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <div class="dropzone-copy">
      <p class="dropzone-title">Drag &amp; Drop file here</p>
      <p class="dropzone-sub">or click to browse — BIN, HEX, MOD, ORI</p>
    </div>
    <span class="browse-btn">
      <span class="browse-btn-label">Browse File</span>
    </span>
  </label>
</div>
